import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { FILE_BASE_URL } from '../../Services/baseApiUrl';

function ContainerDetails() {
    const navigate = useNavigate();
    const location = useLocation();
    const containerDetails = location.state?.containerDetails || {};
    const getImageSource = (file) => {
        return FILE_BASE_URL + file;
    };

    return (
        <div>
            <div style={{ width: "100%" }}>
                <div className="content">
                    <div className="page-content">
                        <div className="page-header">
                            <div className='row text-end'>
                                <div className='col'>
                                    <button type="button" class="btn btn-danger"
                                        style={{
                                            backgroundColor: "rgb(236, 17, 23)"
                                        }}
                                        onClick={() => navigate("/container-master")}
                                    >
                                        Back
                                    </button>
                                </div>
                            </div>
                            <h4 style={{ display: "flex", marginBottom: "30px" }}>
                                Container Details of :  {containerDetails.container_name}
                            </h4>
                            <div className="card">
                                <div className="p-3">
                                    <div className="text-start mb-3">
                                        <div className="row">
                                            <div className="col-md-4 mb-3">
                                                <div className="form-group">
                                                    <label className="form-label">Container Name</label>
                                                    <input
                                                        type="text"
                                                        name="container_name"
                                                        className="form-control"
                                                        readOnly
                                                        value={containerDetails.container_name}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4 mb-3">
                                                <div className="form-group">
                                                    <label className="form-label">Container Code</label>
                                                    <input
                                                        type="text"
                                                        name="container_code"
                                                        className="form-control"
                                                        readOnly
                                                        value={containerDetails.container_code}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4 mb-3">
                                                <div className="form-group">
                                                    <label className="form-label">Container Capacity</label>
                                                    <input
                                                        type="text"
                                                        name="container_capacity"
                                                        className="form-control"
                                                        readOnly
                                                        value={containerDetails.container_capacity}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-md-4 mb-3">
                                                <div className="form-group">
                                                    <label className="form-label">Type Of Container</label>
                                                    <input
                                                        type="text"
                                                        name="type_of_container"
                                                        className="form-control"
                                                        readOnly
                                                        value={containerDetails.type_of_container}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4 mb-3">
                                                <div className="form-group">
                                                    <label className="form-label">Brand</label>
                                                    <input
                                                        type="text"
                                                        name="container_brand"
                                                        className="form-control"
                                                        readOnly
                                                        value={containerDetails.container_brand}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4 mb-3">
                                                <div className="form-group">
                                                    <label className="form-label">File</label>
                                                    {containerDetails.file && (
                                                        <img
                                                            src={getImageSource(containerDetails.file)}
                                                            alt="Container Image"
                                                            style={{ maxWidth: "100%", marginTop: "10px" }}
                                                        />
                                                    )}
                                                </div>
                                            </div>

                                            <div className="col-md-4 mb-3">
                                                <div className="form-group">
                                                    <label className="form-label">Status</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="status"
                                                        readOnly
                                                        value={containerDetails.status === "1" ? "Active" : "Inactive"}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ContainerDetails
